import { Pipe, PipeTransform } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Exercise } from 'src/models/exercise.model';
import { ExerciseService } from 'src/services/exercise-service.service';

@Pipe({
    name: 'getExercise',
    standalone: false
})
export class GetExercisePipe implements PipeTransform {
  constructor(private exerciseService: ExerciseService) {}

  transform(exerciseId: string): Observable<Exercise | null> {
    return from(this.exerciseService.getExercise(exerciseId)).pipe(
      map((exercise) => exercise || null), // Convert undefined to null
      catchError((error) => {
        console.error('Error fetching exercise:', error);
        return of(null); // Return an Observable that emits null
      })
    );
  }
}
